import React from 'react';
import { ChakraProvider, CSSReset } from '@chakra-ui/core';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

//?styles
import './styles/globals.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

//?util
import theme from './util/theme';
import ScrollToTop from './util/ScrollToTop';

//?components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Up from './components/layout/Up';

//?pages
import Home from './pages/index';
import Orders from './pages/orders';
import Favories from './pages/favories';
import Profile from './pages/profile';
import Cart from './pages/cart';
import Restaurants from './pages/restaurants';
import Restaurant from './pages/restaurant';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <CSSReset />

      <Router>
        <ScrollToTop></ScrollToTop>
        <Navbar></Navbar>
        <Switch>
          <Route title="home" exact path="/">
            <Home />
          </Route>
          <Route title="orders" path="/orders">
            <Orders />
          </Route>
          <Route title="favories" path="/favories">
            <Favories />
          </Route>
          <Route title="profile" path="/profile">
            <Profile />
          </Route>
          <Route title="cart" path="/cart">
            <Cart />
          </Route>
          <Route title="restaurants" path="/restaurants">
            <Restaurants />
          </Route>
          <Route title="restaurant" path="/restaurant/:id">
            <Restaurant />
          </Route>
        </Switch>
        <Up></Up>
        <Footer></Footer>
      </Router>
    </ChakraProvider>
  );
}

export default App;
